import DisclaimerSvg from "../../assets/icons/svgs/disclaimer.svg";

export const Disclaimer = ({ text, img = null, style = {}, type = 'with-icon'}) => {

  switch(type) {
    case 'with-icon':
      return text ? (
        <div style={{ display: "flex", alignItems: "flex-start", gap: "4px",...style }}>
          {img || (
            <img
              alt="disclaimer"
              style={{ marginTop: "1.5px" }}
              src={DisclaimerSvg}
            ></img>
          )}
          <span
            style={{
              color: "#797E86",
              fontSize: 12
            }}
          >
            {text}
          </span>
        </div>
      ): <></>;
    case 'without-icon':
      return text ? (
        <div style={{ display: "flex", alignItems: "flex-start", gap: "4px",background: "#F2F2F3", padding: '8px 16px', borderRadius: '8px', ...style }}>
          <span
            style={{
              color: "#0C0D0D",
              fontSize: 14
            }}
          >
            {text}
          </span>
        </div>
      ): <></>;
    default:
      return <></>;
      
  }

};
